import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { CampanhaROIWidgetRecursoComponent } from './recurso';
import { CampanhaROIWidgetResultadoComponent } from './resultado';
import { CampanhaROIWidgetROIComponent } from './roi';
import { CampanhaROIWidgetsComponent } from './campanha-roi-widgets.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaROIWidgetRecursoComponent,
        CampanhaROIWidgetResultadoComponent,
        CampanhaROIWidgetROIComponent,
        CampanhaROIWidgetsComponent
    ],
    exports: [
        CampanhaROIWidgetRecursoComponent,
        CampanhaROIWidgetResultadoComponent,
        CampanhaROIWidgetROIComponent,
        CampanhaROIWidgetsComponent
    ]
})
export class CampanhaROIWidgetsModule { }
